import { Box, TagColor as Color, Tag } from '@factorialco/deprecated-design-system'
import { PerformanceInsightsQuantityEnum } from 'generated/resources/datatable.graphql'

import { scoreTranslations } from 'modules/performance_process/components/insights/TargetCard'

interface Props {
  alignmentScore: PerformanceInsightsQuantityEnum
}

const scoreColors = (alignmentScore: PerformanceInsightsQuantityEnum): Color => {
  switch (alignmentScore) {
    case 'high':
      return Color.viridian
    case 'normal':
      return Color.grey
    case 'low':
      return Color.radical
    default:
      const _exhaustiveCheck: never = alignmentScore
      throw new Error(`Unhandled quality: ${_exhaustiveCheck}`)
  }
}

export const AlignmentScoreTag = ({ alignmentScore }: Props) => {
  const label = scoreTranslations(alignmentScore)
  const color = scoreColors(alignmentScore)

  return (
    <Box>
      <Tag leftItem="circle" showCircle size="normal" inline capitalize type={color}>
        {label}
      </Tag>
    </Box>
  )
}
